import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { CatalogueEntry } from "../CatalogueEntry";
import NoteType from "../../../Models/Catalogue/Generic/NoteType";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class NoteTypeCatalogueEntry extends CatalogueEntry<NoteType> {

    constructor() {
        super("Note Types", NoteType);
    }

    public get editRole() {
        return CatalogueRoles.NoteTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.noteTypes;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveNoteTypes;
    }
    
    public renderRow(item: NoteType, meta: Model.TransformMetaType<NoteType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.noteTypeName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}